import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { CheckValidation, convertToISOFormat } from "../Utils/common";
import {
  CustomGetAPI,
  CustomPostAPI,
  CustomPutAPI,
} from "../Utils/APIConnector";
import { useLocation } from "react-router-dom";
import Loader from "../Utils/Loader";
import Swal from "sweetalert2";
import Select from "react-select";

export const DaysOfWeek = [
  {
    value: 1,
    label: "Mon",
  },
  {
    value: 2,
    label: "Tue",
  },
  {
    value: 3,
    label: "Wed",
  },
  {
    value: 4,
    label: "Thu",
  },
  {
    value: 5,
    label: "Fri",
  },
  {
    value: 6,
    label: "Sat",
  },
  {
    value: 7,
    label: "Sun",
  },
];

export default function AddCoupon() {
  const UserType = window.localStorage.getItem("UserType");
  const UserId = window.localStorage.getItem("userid");
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [couponList, setCouponList] = useState([]);
  const [venueMultiSelect, setVenueMultiSelect] = useState([]);
  const [gotAllVenues, setGotAllVenues] = useState(0);
  const [allErrors, setAllErrors] = useState({
    errorId: 0,
    errorMsg: "",
  });
  const [venuesList, setVenuesList] = useState([
    {
      value: 0,
      label: "All",
    },
  ]);
  const [sportList, setSportList] = useState([
    {
      value: 0,
      label: "All",
    },
  ]);
  const [couponData, setCouponData] = useState(() => {
    const today = new Date();
    const nextMonth = new Date(
      today.getFullYear(),
      today.getMonth() + 1,
      today.getDate()
    );

    // Handle month overflow (e.g., Jan 31 → Feb)
    if (nextMonth.getMonth() !== (today.getMonth() + 1) % 12) {
      nextMonth.setDate(0); // last day of the previous month
    }

    return {
      name: "",
      startDate: today,
      endDate: nextMonth,
      percentDiscount: "",
      amountDiscount: "",
      startHours: "",
      endHours: "",
      duration: "",
      selectedDays: [],
      couponType: 2,
      daysPrefernce: 0,
      hoursPrefernce: 0,
      selectedSport: [],
    };
  });

  useEffect(() => {
    if (
      UserType != "Hybrid" &&
      UserType != "Admin" &&
      UserType != "Venueowner"
    ) {
      window.location.href = "/home";
    }
  }, []);

  useEffect(() => {
    if (UserId) {
      CustomGetAPI(
        `/Venue/GetAllVenuesById/${UserId}/${
          couponData.selectedSport?.[0]?.value || 0
        }`
      ).then((result) => {
        if (result) {
          result = JSON.parse(result);
          if (result.status === "Success") {
            setVenuesList([
              { value: 0, label: "All" },
              ...result?.data?.venues?.map((item) => ({
                value: item.id,
                label: item.venueName,
              })),
            ]);
            setGotAllVenues(1);
          } else {
            return false;
          }
        }
      });
    }
  }, [location.state, couponData.selectedSport]);

  useEffect(() => {
    if (UserId) {
      CustomGetAPI(`/Venue/GetAllSportsForVenue/${UserId}`).then((result) => {
        if (result) {
          result = JSON.parse(result);
          if (result.status === "Success") {
            setCouponList(result.data.couponList);
            result?.data?.surfaceList?.map((item) => {
              setSportList((prevList) => [
                ...prevList,
                { value: item.value, label: item.label },
              ]);
            });
            setGotAllVenues(2);
          } else {
            return false;
          }
        }
      });
    }
  }, [location.state]);

  useEffect(() => {
    if (location.state?.couponId) {
      setIsLoading(true);
      CustomGetAPI(`/venue/GetOffers/${location.state.couponId}/true`).then(
        (result) => {
          if (result) {
            result = JSON.parse(result);
            const venueIds = result?.data?.venueId
              ?.split(",")
              .map((id) => parseInt(id.trim(), 10));
            if (venueIds?.length === venuesList?.length - 1) {
              setVenueMultiSelect(venuesList[0]);
            } else {
              const selectedVenues = venuesList?.filter((venue) =>
                venueIds?.includes(venue.value)
              );
              setVenueMultiSelect(selectedVenues);
            }
            const weekdaysArray = result?.data?.weekDays?.split(", ");
            const SportIds = result?.data?.sportIds
              ?.split(",")
              .map((sportId) => parseInt(sportId));
            let selectedSport;
            if (sportList?.length - 1 === SportIds.length) {
              selectedSport = [sportList?.[0]];
            } else {
              selectedSport = sportList?.filter((sport) =>
                SportIds.includes(sport.value)
              );
            }

            setCouponData((prevState) => ({
              ...prevState,
              name: result?.data?.code,
              startDate: new Date(result?.data?.createdDate),
              endDate: new Date(result?.data?.expiry),
              percentDiscount: result?.data?.offpercentage,
              amountDiscount: result?.data?.amountLimit,
              couponType: result?.data?.couponTypeId,
              duration:
                result?.data?.duration === 1
                  ? `${result?.data?.duration} hr`
                  : `${result?.data?.duration} hrs`,
              selectedDays: weekdaysArray.length === 7 ? [] : weekdaysArray,
              startHours: result?.data?.offerStartTime,
              endHours:
                result?.data?.offerEndTime === "23:59"
                  ? "00:00"
                  : result?.data?.offerEndTime,
              daysPrefernce: weekdaysArray.length === 7 ? 0 : 1,
              hoursPrefernce:
                result?.data?.offerStartTime === "00:00" &&
                result?.data?.offerEndTime === "23:59"
                  ? 0
                  : 1,
              selectedSport: selectedSport,
            }));
            setIsLoading(false);
          }
        }
      );
    }
  }, [location.state, gotAllVenues]);

  useEffect(() => {
    if (couponData.selectedDays.length >= 7) {
      setCouponData({ ...couponData, daysPrefernce: 0, selectedDays: [] });
    }
  }, [couponData.selectedDays]);

  const handleSurfaceTypes = (selected) => {
    // setSelectedSport([selected])
    if (selected && selected.label === "All") {
      setCouponData({ ...couponData, selectedSport: [sportList[0]] });
    } else {
      setCouponData({ ...couponData, selectedSport: [selected] });
    }
    // const FilteredOptions = selected.filter((option) => option.label === "All");
    // if (FilteredOptions.length > 0) {
    //   setSelectedSport(FilteredOptions);
    // } else {
    //   setSelectedSport(selected);
    // }
  };

  const handleSelectChange = (selected) => {
    if (selected.length > 1 && selected[0].label === "All") {
      selected = selected.filter((item) => item.value !== 0);
    }
    const FilteredOptions = selected.filter((option) => option.label === "All");
    if (selected.length === venuesList.length - 1) {
      selected = venuesList[0];
      setVenueMultiSelect(venuesList[0]);
    }
    if (FilteredOptions.length > 0) {
      setVenueMultiSelect(FilteredOptions);
    } else {
      setVenueMultiSelect(selected);
    }
  };

  const handleSubmit = () => {
    var isFormValid = CheckValidation({ formID: "couponPopup" });

    if (!couponData?.startDate) {
      isFormValid = false;
      const startError = document.getElementById("startDateError");
      startError.classList.remove("d-none");
    } else {
      const startError = document.getElementById("startDateError");
      startError.classList.add("d-none");
    }

    if (!couponData?.endDate) {
      isFormValid = false;
      const endError = document.getElementById("endDateError");
      endError.classList.remove("d-none");
    } else {
      const endError = document.getElementById("endDateError");
      endError.classList.add("d-none");
    }

    if (parseInt(couponData?.percentDiscount) > 100) {
      setAllErrors({
        ...allErrors,
        errorId: 8,
        errorMsg: "Discount % can't be greater than 100",
      });
      return;
    }

    if (couponData?.endDate < couponData?.startDate) {
      setAllErrors({
        ...allErrors,
        errorId: 9,
        errorMsg: "Start Date can't be small than expiry date",
      });
      return;
    }

    if (!isFormValid) {
      return;
    }

    if (isFormValid && !location.state?.couponId) {
      const raw = JSON.stringify({
        code: couponData?.name,
        CreatedDate: convertToISOFormat(couponData?.startDate),
        Expiry: convertToISOFormat(couponData?.endDate),
        Offpercentage: couponData?.percentDiscount || 0,
        AmountLimit: couponData?.amountDiscount,
        UserId: UserType == "Admin" ? 0 : parseInt(UserId, 10),
        venueId:
          !Array.isArray(venueMultiSelect) ||
          venueMultiSelect.length === 0 ||
          venueMultiSelect?.some((item) => item.label === "All")
            ? venuesList
                .filter((item) => item.value !== 0)
                .map((venueIds) => venueIds.value)
                .join()
            : venueMultiSelect.map((item) => item.value).join(),
        weekDays:
          couponData?.daysPrefernce === 0
            ? "Mon,Tue,Wed,Thu,Fri,Sat,Sun"
            : couponData.selectedDays.join(),
        offerStartTime: couponData.startHours || "00:00",
        offerEndTime: couponData.endHours || "00:00",
        duration:
          couponData.duration === "None" || couponData.duration === ""
            ? 0
            : parseInt(couponData.duration),
        couponTypeId: couponData.couponType,
        SportIds:
          couponData.selectedSport.length === 0 ||
          couponData.selectedSport[0].value === 0
            ? sportList
                .slice(1, sportList.length)
                .map((item) => item.value)
                .join()
            : `${couponData.selectedSport[0].value}`,
      });
      setIsLoading(true);
      setAllErrors({ errorId: 0, errorMsg: "" });
      CustomPostAPI("/venue/Createoffer", raw).then((result) => {
        if (result) {
          result = JSON.parse(result);
          if (result?.status === "success") {
            setIsLoading(false);
            Swal.fire({
              icon: "success",
              title: "Congratulations!",
              text: "Coupon Created Successfully",
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.href = "/coupon-home";
              }
            });
          } else {
            setIsLoading(false);
            Swal.fire({
              icon: "error",
              title: "Sorry!",
              text: result?.message,
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload();
              }
            });
          }
        }
      });
    } else {
      const raw = JSON.stringify({
        Id: location.state?.couponId,
        code: couponData?.name,
        CreatedDate: convertToISOFormat(couponData?.startDate),
        Expiry: convertToISOFormat(couponData?.endDate),
        Offpercentage:
          couponData.couponType === 1 ? 0 : couponData?.percentDiscount,
        AmountLimit: couponData?.amountDiscount || 0,
        venueId:
          !Array.isArray(venueMultiSelect) ||
          venueMultiSelect.length === 0 ||
          venueMultiSelect?.some((item) => item.label === "All")
            ? venuesList
                .filter((item) => item.value !== 0)
                .map((venueIds) => venueIds.value)
                .join()
            : venueMultiSelect.map((item) => item.value).join(),
        weekDays:
          couponData?.daysPrefernce === 0
            ? "Mon,Tue,Wed,Thu,Fri,Sat,Sun"
            : couponData.selectedDays.join(),
        offerStartTime:
          couponData?.hoursPrefernce !== 0 ? couponData.startHours : "00:00",
        offerEndTime:
          couponData.hoursPrefernce !== 0 ? couponData.endHours : "00:00",
        duration:
          couponData.duration === "None" ? 0 : parseInt(couponData.duration),
        couponTypeId: couponData.couponType,
        SportIds:
          couponData?.selectedSport?.length === 0 ||
          couponData?.selectedSport[0]?.value === 0
            ? sportList
                ?.slice(1, sportList.length)
                ?.map((item) => item.value)
                .join()
            : `${couponData.selectedSport[0].value}`,
      });
      setIsLoading(true);
      CustomPutAPI(`/venue/EditOffer`, raw).then((result) => {
        if (result) {
          result = JSON.parse(result);
          if (result?.status === "success") {
            setIsLoading(false);
            Swal.fire({
              icon: "success",
              title: "Congratulations!",
              text: "Coupon Updated Successfully",
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.href = "/coupon-home";
              }
            });
          } else {
            setIsLoading(false);
            Swal.fire({
              icon: "error",
              title: "Sorry!",
              text: result?.message,
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload();
              }
            });
          }
        }
      });
    }
  };

  const generateTimeOptions = () => {
    const options = [];
    for (let i = 0; i < 24; i++) {
      const amPm = i < 12 ? "AM" : "PM";
      const hour = (i % 12 ? i % 12 : 12).toString().padStart(2, "0");
      const hourValue = i.toString().padStart(2, "0");
      options.push(
        <option key={hourValue} value={`${hourValue}:00`}>
          {hour}:00 {amPm}
        </option>
      );
    }
    return options;
  };

  return (
    <React.Fragment>
      {isLoading ? (
        <Loader />
      ) : (
        <div id="couponPopup">
          <div className="col-1 ps-0">
            <img
              src="/images/backArrow.svg"
              onClick={() => {
                window.location.href = "/coupon-home";
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
          <div className="text-center">
            <h5 className="colorClass text-center">
              {location.state?.couponId ? "Edit Coupon" : "New Coupon"}
            </h5>
          </div>
          <div className="shadow p-4 rounded mb-3 mt-3">
            <div className="mt-2 parent">
              <b>Coupon Code :</b>
              <input
                className="form-control mt-2"
                type="text"
                required
                value={couponData?.name}
                name="name"
                id="coupon"
                placeholder="Coupon Code*"
                onChange={(e) =>
                  setCouponData((prevData) => ({
                    ...prevData,
                    [e.target.name]: e.target.value,
                  }))
                }
              />
              <span className="form-text invalid-feedback">
                * This field is Required!
              </span>
            </div>
            <div className="row mt-3">
              <div className="col-md-6 col-12 parent">
                <b>Sports</b>
                <Select
                  value={
                    couponData.selectedSport.length > 0
                      ? couponData.selectedSport
                      : sportList[0]
                  }
                  // value={selectedSport}
                  options={sportList}
                  onChange={(selected) => handleSurfaceTypes(selected)}
                  className="customize-select mt-2 custom-border-select"
                />
              </div>
              <div className="col-12 col-md-6 parent">
                <b>Venues :</b>
                <Select
                  value={
                    venueMultiSelect.length === 0
                      ? venuesList[0]
                      : venueMultiSelect
                  }
                  options={venuesList}
                  className="customize-select mt-2 custom-border-select"
                  onChange={(selected) => handleSelectChange(selected)}
                  isMulti
                  closeMenuOnSelect={false}
                  // isDisabled={couponData.selectedSport.length === 0}
                />
              </div>
            </div>
            <div className="d-flex gap-4 mt-4">
              <div className="d-flex gap-2 align-items-center">
                <input
                  type="radio"
                  id="AllDays"
                  value={0}
                  checked={couponData?.daysPrefernce === 0}
                  className="form-check-input me-1 cursor-pointer"
                  onChange={(e) =>
                    setCouponData({
                      ...couponData,
                      daysPrefernce: parseInt(e.target.value),
                    })
                  }
                />
                <span
                  className="cursor-pointer"
                  onClick={() =>
                    setCouponData({ ...couponData, daysPrefernce: 0 })
                  }
                >
                  All Days of Week
                </span>
              </div>
              <div className="d-flex gap-2 align-items-center">
                <input
                  type="radio"
                  id="SpecificDays"
                  value={1}
                  checked={couponData?.daysPrefernce === 1}
                  className="form-check-input me-1 cursor-pointer"
                  onChange={(e) =>
                    setCouponData({
                      ...couponData,
                      daysPrefernce: parseInt(e.target.value),
                    })
                  }
                />
                <span
                  className="cursor-pointer"
                  onClick={() =>
                    setCouponData({ ...couponData, daysPrefernce: 1 })
                  }
                >
                  Specific Days
                </span>
              </div>
            </div>
            {couponData?.daysPrefernce === 1 && (
              <div
                className="row mx-0 mt-4 py-3 px-2"
                style={{ backgroundColor: "rgb(241, 241, 241)" }}
              >
                <div className="col-12 checkBoxLabel">
                  {DaysOfWeek.map((day, index) => (
                    <div className="checkbox-container" key={index}>
                      <input
                        className="custom-checkbox"
                        type="checkbox"
                        id={day.label}
                        checked={couponData.selectedDays.includes(day.label)}
                        onChange={() => {
                          setCouponData((prevData) => ({
                            ...prevData,
                            selectedDays: prevData.selectedDays.includes(
                              day.label
                            )
                              ? prevData.selectedDays.filter(
                                  (d) => d !== day.label
                                )
                              : [...prevData.selectedDays, day.label],
                          }));
                        }}
                      />
                      <label htmlFor={day.label}>{day.label}</label>
                    </div>
                  ))}
                </div>
              </div>
            )}
            <div className="d-flex gap-4 mt-4">
              <div className="d-flex gap-2 align-items-center">
                <input
                  type="radio"
                  id="fullday"
                  value={0}
                  checked={couponData?.hoursPrefernce === 0}
                  className="form-check-input me-1 cursor-pointer"
                  onChange={(e) =>
                    setCouponData({
                      ...couponData,
                      hoursPrefernce: parseInt(e.target.value),
                    })
                  }
                />
                <span
                  className="cursor-pointer"
                  onClick={() =>
                    setCouponData({ ...couponData, hoursPrefernce: 0 })
                  }
                >
                  Full Day
                </span>
              </div>
              <div className="d-flex gap-2 align-items-center">
                <input
                  type="radio"
                  id="specifichours"
                  value={1}
                  checked={couponData?.hoursPrefernce === 1}
                  className="form-check-input me-1 cursor-pointer"
                  onChange={(e) =>
                    setCouponData({
                      ...couponData,
                      hoursPrefernce: parseInt(e.target.value),
                    })
                  }
                />
                <span
                  className="cursor-pointer"
                  onClick={() =>
                    setCouponData({ ...couponData, hoursPrefernce: 1 })
                  }
                >
                  Specific Hours
                </span>
              </div>
            </div>
            {couponData?.hoursPrefernce === 1 && (
              <div className="row mt-4">
                <div className="col-6">
                  <b>Start Time :</b>
                  <select
                    value={couponData?.startHours}
                    className="form-control time-select mt-2"
                    onChange={(e) =>
                      setCouponData({
                        ...couponData,
                        startHours: e.target.value,
                      })
                    }
                  >
                    {generateTimeOptions()}
                  </select>
                </div>
                <div className="col-6">
                  <b>End Time :</b>
                  <select
                    value={couponData?.endHours}
                    className="form-control time-select mt-2"
                    onChange={(e) =>
                      setCouponData({
                        ...couponData,
                        endHours: e.target.value,
                      })
                    }
                  >
                    {generateTimeOptions()}
                  </select>
                </div>
              </div>
            )}
            <div className="row mt-4">
              <div className="col-12 col-md-6 parent mt-md-0 mt-3">
                <b>Coupon Type :</b>
                <select
                  className="customize-select mt-2 form-control"
                  value={couponData.couponType}
                  onChange={(e) =>
                    setCouponData({
                      ...couponData,
                      couponType: parseInt(e.target.value),
                    })
                  }
                  disabled={location.pathname === "/edit-coupon" ? true : false}
                >
                  {couponList &&
                    couponList.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="col-md-6 col-12 parent mt-3 mt-md-0">
                <b>Min Duration</b>
                <select
                  value={couponData?.duration}
                  className="customize-select form-control mt-2"
                  onChange={(e) =>
                    setCouponData({ ...couponData, duration: e.target.value })
                  }
                >
                  {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item) => (
                    <option key={item}>
                      {item === 0
                        ? "None"
                        : item === 1
                        ? `${item} hr`
                        : `${item} hrs`}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-6">
                <b>Start Date :</b>
                <DatePicker
                  className="form-control mt-2"
                  placeholderText="Select Date*"
                  name="startDate"
                  minDate={new Date()}
                  autoComplete="off"
                  utcOffset={0}
                  selected={couponData?.startDate}
                  onChange={(date) =>
                    setCouponData((prevData) => ({
                      ...prevData,
                      startDate: date,
                      endDate: date,
                    }))
                  }
                  onFocus={(e) => (e.target.readOnly = true)}
                />
                <span
                  id="startDateError"
                  className="form-text text-danger d-none"
                >
                  * This field is Required!
                </span>
                {allErrors.errorId === 9 && (
                  <label className="text-danger custom-fs-14 mt-2">
                    {allErrors.errorMsg}
                  </label>
                )}
              </div>
              <div className="col-6">
                <b>Expiry Date :</b>
                <DatePicker
                  className="form-control mt-2"
                  placeholderText="Select Date*"
                  name="endDate"
                  minDate={
                    couponData?.startDate ||
                    new Date().setDate(new Date().getDate() + 1)
                  }
                  utcOffset={0}
                  autoComplete="off"
                  selected={couponData?.endDate}
                  onChange={(date) =>
                    setCouponData((prevData) => ({
                      ...prevData,
                      endDate: date,
                    }))
                  }
                  onFocus={(e) => (e.target.readOnly = true)}
                />
                <span
                  id="endDateError"
                  className="form-text text-danger d-none"
                >
                  * This field is Required!
                </span>
              </div>
            </div>
            <div className="row mt-3">
              {couponData.couponType === 2 && (
                <div className="col-6 parent">
                  <b>Discount % :</b>
                  <input
                    type="number"
                    name="percentDiscount"
                    id="percentageDiscount"
                    required
                    max={100}
                    className="form-control mt-2"
                    value={couponData?.percentDiscount}
                    placeholder="Max Percentage Discount*"
                    onChange={(e) => {
                      if (e.target.value.length > 3) {
                        return;
                      }
                      setCouponData((prevData) => ({
                        ...prevData,
                        [e.target.name]: e.target.value,
                      }));
                    }}
                  />
                  <span className="form-text invalid-feedback">
                    * This field is Required!
                  </span>
                  {allErrors.errorId === 8 && (
                    <label className="text-danger custom-fs-14 mt-2">
                      {allErrors.errorMsg}
                    </label>
                  )}
                </div>
              )}
              <div className="col-6 parent">
                <b>{couponData.couponType !== 1 && "Upto"} Amount :</b>
                <input
                  className="form-control mt-2"
                  type="number"
                  name="amountDiscount"
                  id="maxDiscount"
                  required
                  value={couponData?.amountDiscount}
                  placeholder={`${
                    couponData.couponType !== 1 ? "Max" : ""
                  } Discount Amount*`}
                  onChange={(e) =>
                    setCouponData((prevData) => ({
                      ...prevData,
                      [e.target.name]: e.target.value,
                    }))
                  }
                />
                <span className="form-text invalid-feedback">
                  * This field is Required!
                </span>
              </div>
            </div>
            <div className="text-center mt-5">
              <button className="btn btn-danger w-50" onClick={handleSubmit}>
                <b>Submit</b>
              </button>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}
